import { render, staticRenderFns } from "./GuessLike.vue?vue&type=template&id=09fe99eb&scoped=true"
import script from "./GuessLike.vue?vue&type=script&lang=js"
export * from "./GuessLike.vue?vue&type=script&lang=js"
import style0 from "./GuessLike.vue?vue&type=style&index=0&id=09fe99eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe99eb",
  null
  
)

export default component.exports